import React, { useState } from 'react';

import { ProductProvider } from './ProductContext';
import { SubscriptionProvider } from './SubscriptionContext';
import { UIProvider } from './UIContext';
import { AppProvider } from './AppContext';

export const AppProviders = ({ children }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlClientId = urlParams.get('client_id');
  const urlClientTitle = (urlParams.get('client_title') || urlParams.get('amp;client_title'))?.split('_').join(' ');

  const savedClientId = localStorage.getItem('client_id');
  const savedClientTitle = localStorage.getItem('client_title');

  const clientId = urlClientId || savedClientId;
  const clientTitle = urlClientTitle || savedClientTitle;

  if (urlClientTitle) {
    window.APP_NAME = clientTitle || '';
    localStorage.setItem('client_title', urlClientTitle);
  } else {
    localStorage.removeItem('client_title');
  }

  if (clientId) {
    window.APP_ID = +clientId;
    localStorage.setItem('client_id', clientId);
  }

  const [appId] = useState(clientId);

  if (!appId) {
    return null;
  }

  return (
    <AppProvider>
      <ProductProvider>
        <SubscriptionProvider>
          <UIProvider>{children}</UIProvider>
        </SubscriptionProvider>
      </ProductProvider>
    </AppProvider>
  );
};
